import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API } from "../App";
import Header from "../components/layout/Header";
import { FileText, Loader2 } from "lucide-react";
import axios from "axios";
import { useLocalized } from "../utils/localized";

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchPage = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/pages/${slug}`);
        setPage(res.data);
      } catch (error) {
        if (error.response?.status === 404) {
          setNotFound(true);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, [slug]);

  const title = useLocalized(page, "title");
  const content = useLocalized(page, "content");

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {loading ? (
            <div className="flex items-center justify-center py-24">
              <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            </div>
          ) : notFound ? (
            <div className="text-center py-24">
              <FileText className="h-16 w-16 text-muted-foreground/30 mx-auto mb-4" />
              <h1 className="text-2xl font-medium text-foreground mb-2">Page Not Found</h1>
              <p className="text-muted-foreground">The page you're looking for doesn't exist.</p>
            </div>
          ) : (
            <article data-testid="cms-page-content">
              <h1 className="text-4xl font-medium text-foreground mb-8">{title}</h1>
              <div
                className="prose prose-stone max-w-none [&_h1]:text-3xl [&_h1]:font-medium [&_h1]:mb-4 [&_h2]:text-2xl [&_h2]:font-medium [&_h2]:mb-3 [&_h2]:mt-8 [&_h3]:text-xl [&_h3]:font-medium [&_h3]:mb-2 [&_h3]:mt-6 [&_p]:text-base [&_p]:text-muted-foreground [&_p]:mb-4 [&_p]:leading-relaxed [&_a]:text-primary [&_a]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-4 [&_li]:text-muted-foreground [&_li]:mb-1"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            </article>
          )}
        </div>
      </div>
    </div>
  );
}
